import React, { Component } from 'react';
import { observer } from 'mobx-react';

import ReferrerGrid from './ReferrerGrid';
import TransactionList from './TransactionList';
import ChartUI from './ChartUI';

import TrendAnalysisStore from '../stores/TrendAnalysisStore';

class TrendAnalysisUI extends Component {

    constructor(props) {
        super(props);
        this.store = new TrendAnalysisStore({ apiProxy: props.appStore.apiProxy })
    }

    chartOrTransactionGrid = () => {
        if(this.store.selectedRefId !== '' && this.store.isClicked)
        {
            return (
                <div style={{ width: '50%' }}>
                    <TransactionList store={this.store} />
                </div>
            )
        }
        return (
            <div style={{ width: '50%' }}>
                <ChartUI store={this.store} />
            </div>
        )
    }

    render() {
        return (  
            <div style={{ display: 'flex', flexDirection: 'row', paddingBottom: "5px" }} >
                <div style={{ width: '50%' }}>
                    <ReferrerGrid store={this.store} title = "Referrers"/>
                </div>
                { this.chartOrTransactionGrid()}
            </div>
        )
    }
}

export default observer(TrendAnalysisUI)
